import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import LicenseExpiryWarningNotification from '../../licenseExpiryWarningNotification';
import { ReceptionContainer } from '../list/ReceptionContainer';
import { useAuthentication } from '../../authentiction';

export const ReceptionShell: React.FC = () => {
  const { onLogout } = useAuthentication();

  return (
    <>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Navbar.Brand as={Link} to="/reception">
          Vis<sup>IT</sup> Reception
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            <NavLink to="/reception" exact className="nav-link">
              Home
            </NavLink>
            <NavLink to="/reception/badges" className="nav-link">
              Badges
            </NavLink>
            <NavLink to="/" exact className="nav-link" onClick={onLogout}>
              Logout
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <LicenseExpiryWarningNotification />
      <ReceptionContainer />
    </>
  );
};
